// Barrel export for Campaign Detail
export {CampaignDetail} from "./CampaignDetail";
